
// export const myGetter = ( state ) => {
//  return state
// }

export const companiesList = state => state.companies
export const companiesSelectable = state => state.companiesSelectable
export const companiesPaginatedData = state => state.companiesPaginatedData
export const company = state => state.company
export const isLoading = state => state.isLoading
export const isCreating = state => state.isCreating
export const isUpdating = state => state.isUpdating
export const createdData = state => state.createdData
export const updatedData = state => state.updatedData
export const isDeleting = state => state.isDeleting
export const deletedData = state => state.deletedData